import React from "react";

const MAP = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  yellow: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-rose-50 text-rose-700 border-rose-200",
  blue: "bg-sky-50 text-sky-700 border-sky-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export const Badge2 = ({ color = "slate", children, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${MAP[color] || MAP.slate}`}
  >
    {children}
  </span>
);

// Compute a compliance color + label from a validity/expiry date string
export function validityFromDate(dateStr) {
  if (!dateStr) return { color: "slate", label: "Sem validade" };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr);
  const days = Math.ceil((d - today) / 86400000);
  if (days < 0) return { color: "red", label: "Vencido" };
  if (days <= 30) return { color: "yellow", label: `Vence em ${days}d` };
  return { color: "green", label: "Válido" };
}

const STATUS_COLORS = {
  Válido: "green",
  Conforme: "green",
  Concluído: "green",
  Apto: "green",
  "Em Revisão": "yellow",
  "Em Andamento": "yellow",
  "Plano de Acao": "yellow",
  "Plano de Ação": "yellow",
  "Em Investigacao": "yellow",
  "Em Investigação": "yellow",
  Vencido: "red",
  Pendente: "red",
  Aberto: "red",
  Inapto: "red",
  Crítica: "red",
  Alta: "red",
  Média: "yellow",
  Leve: "green",
  Registrado: "blue",
  Admissional: "blue",
};

export function statusColor(status) {
  return STATUS_COLORS[status] || "slate";
}
